// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"InputGroup-module--inputGroup--30Hob"};